import { Component, OnInit, HostListener } from '@angular/core';
import {Router, NavigationEnd} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  userDetails:any;
  searchKeyword: string = '';
  isMenuOpen = false;
  searchActive: boolean = false;
  activeRoute: string = '/';
  isScrolled: boolean = false;
  isAboutPage: boolean = false;

  constructor(private router: Router,private _authService:AuthService) {
    // Subscribe to router events to update active route
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.activeRoute = event.url;
      if (this.activeRoute.includes('?')) {
        this.activeRoute = this.activeRoute.split('?')[0];
      }
      this.isAboutPage = this.activeRoute.includes('/about-us');
    });
  }
  ngOnInit(): void {
    this._authService.user.subscribe(user => {
      this.userDetails = user;
    })
    this.userDetails=this._authService.userValue;

    // Set initial active route
    this.activeRoute = this.router.url;
    if (this.activeRoute.includes('?')) {
      this.activeRoute = this.activeRoute.split('?')[0];
    }
    this.isAboutPage = this.activeRoute.includes('/about-us');

    // Check initial scroll position
    this.isScrolled = window.scrollY > 50;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 50;
  }
  logout(){
    this._authService.logout();
    this.closeMenu();
  }

  onSearch(event: Event): void {
    event.preventDefault();
    if (this.searchKeyword.trim()) {
      this.router.navigate(['/games'], { queryParams: { search: this.searchKeyword } });
    }
    this.closeMenu();
  }
  toggleSearch() {
    this.searchActive = !this.searchActive;
  }

  toggleMenu() {
    const nav = document.querySelector('.nav');
    nav?.classList.toggle('menu-open');
    const menuTrigger = document.querySelector('.menu-trigger');
    menuTrigger?.classList.toggle('active');
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    if (this.isMenuOpen) {
      const nav = document.querySelector('.nav');
      nav?.classList.remove('menu-open');
      const menuTrigger = document.querySelector('.menu-trigger');
      menuTrigger?.classList.remove('active');
      this.isMenuOpen = false;
    }
  }

  routeToPage(page: string) {
    this.router.navigate([page]);
    this.closeMenu();
  }

  isActive(route: string): boolean {
    if (route === './') {
      return this.activeRoute === '/' || this.activeRoute === '';
    }
    return this.activeRoute.includes(route);
  }
}
